import clsx from "clsx"

import useHeightCSSVariable from "@hooks/useHeightCSSVariable"

import { Divider } from "@atoms"

import styles from "./PopoverFooter.module.scss"
import type { PopoverFooterActionsProps, PopoverFooterRootProps } from "./PopoverFooter.types"

function PopoverFooterRoot(props: PopoverFooterRootProps) {
    const { className, children, containerClassName, isFullWidth = false } = props

    const footerRef = useHeightCSSVariable<HTMLDivElement>("--popover-footer-height")

    return (
        <div ref={footerRef} className={clsx(styles.base, containerClassName)}>
            <Divider className={styles.divider} />
            <div
                className={clsx(styles.innerContainer, className, {
                    [styles.fullWidth]: isFullWidth,
                })}
            >
                {children}
            </div>
        </div>
    )
}

function PopoverFooterLeftSide(props: PopoverFooterActionsProps) {
    const { className, children } = props
    return <div className={clsx(styles.leftSide, className)}>{children}</div>
}

function PopoverFooterRightSide(props: PopoverFooterActionsProps) {
    const { className, children } = props
    return <div className={clsx(styles.rightSide, className)}>{children}</div>
}

export default {
    Root: PopoverFooterRoot,
    LeftSide: PopoverFooterLeftSide,
    RightSide: PopoverFooterRightSide,
}
